import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getAllCountryAction, getCurrentSubscriptionPlanAction, getSubscriptionCurrentAction } from "../actions";
import { get } from "lodash";

export const useCurrentPlanData = () => {
    const [planData, setPlanData] = useState({})
    // const reduxDataForCurrentPlan = useSelector((state) =>
    //     get(state, "app.subscriptionCurrentData.response", "")
    // );
    const tenantId = useSelector((state) =>
        get(state, "app.preSignInState.tenantId", "")
    );

    const userId = useSelector((state) =>
        get(state, "app.preSignInData.userId", "")
    );
    const authToken = useSelector((state) =>
        get(state, "app.signInData.authToken", "")
    );

    const dispatch = useDispatch();
    const payload = {
        tenantId: tenantId
    }

    useEffect(() => {
        const fetchCurrentPlan = async () => {
            // if (!reduxDataForCurrentPlan) {
            //     try {
            //         await dispatch(
            //             getSubscriptionCurrentAction({ tenantId, authToken, userId, payload })
            //         ).catch((err) => {
            //             console.log(err);
            //         });
            //     } catch (err) {
            //         console.log(err);
            //     }
            // }
            if (tenantId && authToken && userId) {
                await dispatch(getCurrentSubscriptionPlanAction({ tenantId, authToken, userId, payload }))
                    .then((data) => {
                        const {
                            responseCode: { status = "" },
                            response,
                        } = data;
                        if (status === "Success") {
                            setPlanData(response)
                        } else {
                            console.log("plan list not found");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        };
        if (tenantId) {
            fetchCurrentPlan();
        }

    }, [tenantId, userId, authToken]);

    return planData;
};



